import React, { useState } from "react";
import "./style.scss";
import ButtonCustom from "../../../../features/ButtonCustom/ButtonCustom";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import InputText from "../../../../features/InputText";
import { BasketItem } from "../../../models/BasketItem";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { BASKET_CALCULATE_PROMOTION } from "../../../api/apiRoutes";

interface IProps {
  setPromoCode: (value: string) => void;
  updateBasket: (value: BasketItem[]) => void;
}

const PromotionPanel: React.FC<IProps> = ({ updateBasket, setPromoCode }: IProps) => {
  const { get } = useApiRequest();
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleAddCode = async () => {
    setPromoCode(code);
    const { result, isError, errorTable } = await get(BASKET_CALCULATE_PROMOTION(code));

    if (!isError) {
      updateBasket(result.basket);
      setCode("");
      setError("");
      setSuccess("Kod został poprawnie wykorzystany");
    } else {
      setCode("");
      setSuccess("");
      setError(errorTable);
      setPromoCode("");
    }
  };

  return (
    <div className={"promotion-panel"}>
      <div className={"promotion-header"}>
        <p>Kod rabatowy</p>
        <ButtonCustom
          title={""}
          className={`button-promotion-color`}
          Icon={open ? IoIosArrowUp : IoIosArrowDown}
          iconPosition={"center"}
          onClick={() => setOpen(!open)}
        />
      </div>
      {open && (
        <React.Fragment>
          <div className={"promotion-body"}>
            <InputText
              value={code}
              label={""}
              name={"code"}
              setValue={(value: string) => {
                setCode(value);

              }}
              placeholder={"Wpisz kod"}
            />
            <ButtonCustom
              title={`Zrealizuj`}
              className={`button-promotion-add`}
              onClick={() => handleAddCode()}
              disabled={!Boolean(code)}
            />
          </div>
          {error && (
            <div className={"error-panel"}>
              <p>{error}</p>
            </div>
          )}
          {success && (
              <div className={"success-panel"}>
                <p>{success}</p>
              </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default PromotionPanel;
